<template>
  <v-container fluid>
        <DispatchingRoot></DispatchingRoot>
  </v-container>
</template>

<script>
import DispatchingRoot from "../components/Dispatching/DispatchingRoot";

export default {
    components: { DispatchingRoot }
};
</script>

<style scoped>
h1 {
    margin-bottom: 1rem;
}
</style>
